// Multi-language translations for Business Club France-Latvia

export const translations = {
  fr: {
    // Navigation
    nav: {
      mission: 'Mission',
      services: 'Services',
      process: 'Fonctionnement',
      faq: 'FAQ',
      contact: 'Contact',
    },
    
    // Hero
    hero: {
      eyebrow: 'France – Lettonie',
      title: "Réseau d'affaires France–Lettonie",
      subtitle: "Le Business Club France–Latvia facilite les échanges économiques, les mises en relation et les événements entre entreprises, institutions et acteurs économiques français et lettons.",
      ctaPrimary: 'Soumettre une demande',
      ctaSecondary: 'Proposer un événement',
    },
    
    // Mission
    mission: {
      title: 'Rôle du Business Club',
      description: "Le Business Club France–Latvia agit comme un point d'entrée neutre pour les coopérations économiques entre la France et la Lettonie. Il facilite les échanges, l'orientation des projets et les mises en relation entre entreprises, institutions et décideurs.",
    },
    
    // Services
    services: {
      title: 'Nos actions et services',
      items: [
        {
          id: 1,
          title: 'Mise en relation économique',
          description: 'Facilitation des connexions entre entreprises, partenaires, institutions et acteurs économiques français et lettons.',
          icon: 'network',
        },
        {
          id: 2,
          title: 'Orientation de projets',
          description: "Aide à la clarification de projets économiques, de coopération ou de développement international.",
          icon: 'compass',
        },
        {
          id: 3,
          title: 'Événements économiques',
          description: 'Organisation et promotion de rencontres B2B, conférences et tables rondes thématiques.',
          icon: 'calendar',
        },
        {
          id: 4,
          title: "Accès à l'écosystème local",
          description: 'Mise en relation avec des réseaux professionnels et institutionnels pertinents.',
          icon: 'building',
        },
        {
          id: 5,
          title: 'Coopérations bilatérales',
          description: 'Soutien à des initiatives conjointes entre acteurs français et lettons.',
          icon: 'handshake',
        },
      ],
    },
    
    // Audience
    audience: {
      title: "À qui s'adresse le Business Club",
      items: [
        {
          id: 1,
          title: 'Entreprises françaises',
          description: 'PME et ETI souhaitant développer leurs activités en Lettonie et dans les pays baltes.',
          icon: 'briefcase',
        },
        {
          id: 2,
          title: 'Entreprises lettones',
          description: 'Sociétés lettones cherchant à établir des partenariats avec des acteurs français.',
          icon: 'building2',
        },
        {
          id: 3,
          title: 'Institutions et organisations',
          description: 'Organisations économiques et institutionnelles engagées dans la coopération bilatérale.',
          icon: 'landmark',
        },
      ],
    },
    
    // Process
    process: {
      title: 'Fonctionnement',
      steps: [
        {
          id: 1,
          step: '01',
          title: 'Soumission',
          description: 'Soumettez votre demande via le formulaire de contact',
        },
        {
          id: 2,
          step: '02',
          title: 'Analyse',
          description: 'Votre demande est étudiée par le Business Club',
        },
        {
          id: 3,
          step: '03',
          title: 'Orientation',
          description: 'Mise en relation, orientation ou invitation à un événement',
        },
      ],
    },
    
    // Event
    event: {
      title: 'Proposer un événement',
      description: "Le Business Club France–Latvia accueille les propositions d'événements portées par ses membres ou partenaires : conférences, rencontres B2B, tables rondes ou délégations économiques. Chaque proposition est étudiée afin d'en garantir la pertinence et l'intérêt collectif.",
      cta: 'Proposer un événement',
    },
    
    // FAQ
    faq: {
      title: 'Questions fréquentes',
      items: [
        {
          id: 'faq-1',
          question: "Qu'est-ce que le Business Club France–Latvia ?",
          answer: "Le Business Club France–Latvia est un réseau d'affaires bilatéral qui facilite les échanges économiques, les mises en relation et les initiatives communes entre entreprises, institutions et décideurs français et lettons.",
        },
        {
          id: 'faq-2',
          question: "À qui s'adresse le Business Club France–Latvia ?",
          answer: "Le Business Club s'adresse aux entreprises françaises et lettones, aux dirigeants, aux investisseurs ainsi qu'aux institutions et organisations souhaitant développer des coopérations économiques entre la France et la Lettonie et l'Europe du Nord.",
        },
        {
          id: 'faq-3',
          question: 'Quels types de services propose le Business Club ?',
          answer: "Le Business Club agit comme un point d'entrée neutre. Il facilite les mises en relation, l'orientation des projets, l'organisation d'événements économiques et le développement d'initiatives bilatérales.",
        },
        {
          id: 'faq-4',
          question: 'Comment le Business Club intervient-il dans les projets économiques ?',
          answer: "Le Business Club intervient principalement en amont des projets, en aidant à clarifier le contexte, à identifier les enjeux clés et à mettre en relation les porteurs de projet avec des interlocuteurs pertinents de l'écosystème franco-letton.",
        },
        {
          id: 'faq-5',
          question: 'À quel moment le Business Club peut-il être utile dans un projet ?',
          answer: "Le Business Club est particulièrement utile lors des phases de réflexion, de structuration ou de lancement d'un projet, en apportant des retours d'expérience et un accès ciblé à l'écosystème économique franco-letton.",
        },
        {
          id: 'faq-6',
          question: 'Comment proposer un événement au Business Club France–Latvia ?',
          answer: "Les membres et partenaires peuvent soumettre des propositions d'événements via le site. Chaque proposition est étudiée afin d'en garantir la pertinence et l'intérêt collectif.",
        },
        {
          id: 'faq-7',
          question: 'Comment contacter le Business Club France–Latvia ?',
          answer: "Les demandes peuvent être soumises via le formulaire de contact du site. Elles sont analysées par le Business Club afin de proposer une orientation adaptée ou une mise en relation lorsque cela est pertinent.",
        },
      ],
    },
    
    // Contact Form
    contact: {
      title: 'Soumettre une demande au Business Club',
      disclaimer: "Le Business Club France–Latvia ne fournit pas de prestations commerciales via ce site. Les demandes sont étudiées et orientées selon leur nature.",
      fields: {
        nom: 'Nom / Prénom',
        organisation: 'Organisation',
        fonction: 'Rôle / Fonction',
        email: 'Email',
        telephone: 'Téléphone',
        paysConcernes: 'Pays concernés',
        natureRequest: 'Nature de la demande',
        timeline: 'Échéance du projet',
        message: 'Message / Description',
        consentement: "J'accepte que ma demande soit transmise et traitée par le Business Club France–Latvia.",
      },
      placeholders: {
        nom: 'Votre nom complet',
        organisation: 'Nom de votre organisation',
        fonction: 'Votre fonction',
        email: 'votre@email.com',
        telephone: '+33 6 00 00 00 00',
        paysConcernes: 'Ex: France, Lettonie, Estonie...',
        message: 'Décrivez votre demande...',
      },
      natureOptions: [
        { id: 'mise-en-relation', label: 'Mise en relation' },
        { id: 'projet-export', label: 'Projet export / coopération' },
        { id: 'proposition-evenement', label: "Proposition d'événement" },
        { id: 'information-generale', label: 'Information générale' },
        { id: 'autre', label: 'Autre' },
      ],
      timelineOptions: [
        { id: 'reflexion', label: 'Réflexion' },
        { id: 'court-terme', label: 'Court terme' },
        { id: 'en-cours', label: 'En cours' },
      ],
      submit: 'Soumettre la demande',
      submitting: 'Envoi en cours...',
      success: 'Votre demande a bien été transmise au Business Club France–Latvia. Elle sera analysée et orientée en fonction de sa nature.',
      errorRequired: 'Veuillez remplir tous les champs obligatoires et accepter les conditions.',
      errorNature: 'Veuillez sélectionner au moins une nature de demande.',
      errorEmail: 'Veuillez entrer une adresse email valide.',
      errorGeneral: 'Une erreur est survenue. Veuillez réessayer.',
    },
    
    // Footer
    footer: {
      tagline: "Réseau d'affaires bilatéral France–Lettonie",
      copyright: '© 2025 Business Club France–Latvia. Tous droits réservés.',
      address: 'Miera iela 2, Rīga, LV-1001',
    },
  },
  
  en: {
    // Navigation
    nav: {
      mission: 'Mission',
      services: 'Services',
      process: 'Process',
      faq: 'FAQ',
      contact: 'Contact',
    },
    
    // Hero
    hero: {
      eyebrow: 'France – Latvia',
      title: 'France–Latvia Business Network',
      subtitle: 'The Business Club France–Latvia facilitates economic exchanges, business connections and events between French and Latvian companies, institutions and economic actors.',
      ctaPrimary: 'Submit a request',
      ctaSecondary: 'Propose an event',
    },
    
    // Mission
    mission: {
      title: 'Role of the Business Club',
      description: 'The Business Club France–Latvia acts as a neutral entry point for economic cooperation between France and Latvia. It facilitates exchanges, project guidance and connections between companies, institutions and decision-makers.',
    },
    
    // Services
    services: {
      title: 'Our actions and services',
      items: [
        {
          id: 1,
          title: 'Economic networking',
          description: 'Facilitating connections between French and Latvian companies, partners, institutions and economic actors.',
          icon: 'network',
        },
        {
          id: 2,
          title: 'Project guidance',
          description: 'Assistance in clarifying economic, cooperation or international development projects.',
          icon: 'compass',
        },
        {
          id: 3,
          title: 'Economic events',
          description: 'Organization and promotion of B2B meetings, conferences and thematic round tables.',
          icon: 'calendar',
        },
        {
          id: 4,
          title: 'Access to local ecosystem',
          description: 'Connection with relevant professional and institutional networks.',
          icon: 'building',
        },
        {
          id: 5,
          title: 'Bilateral cooperation',
          description: 'Support for joint initiatives between French and Latvian actors.',
          icon: 'handshake',
        },
      ],
    },
    
    // Audience
    audience: {
      title: 'Who is the Business Club for',
      items: [
        {
          id: 1,
          title: 'French companies',
          description: 'SMEs and mid-sized companies looking to develop their activities in Latvia and the Baltic states.',
          icon: 'briefcase',
        },
        {
          id: 2,
          title: 'Latvian companies',
          description: 'Latvian companies seeking to establish partnerships with French actors.',
          icon: 'building2',
        },
        {
          id: 3,
          title: 'Institutions and organizations',
          description: 'Economic and institutional organizations engaged in bilateral cooperation.',
          icon: 'landmark',
        },
      ],
    },
    
    // Process
    process: {
      title: 'How it works',
      steps: [
        {
          id: 1,
          step: '01',
          title: 'Submission',
          description: 'Submit your request via the contact form',
        },
        {
          id: 2,
          step: '02',
          title: 'Analysis',
          description: 'Your request is reviewed by the Business Club',
        },
        {
          id: 3,
          step: '03',
          title: 'Guidance',
          description: 'Connection, guidance or invitation to an event',
        },
      ],
    },
    
    // Event
    event: {
      title: 'Propose an event',
      description: 'The Business Club France–Latvia welcomes event proposals from its members or partners: conferences, B2B meetings, round tables or economic delegations. Each proposal is reviewed to ensure its relevance and collective interest.',
      cta: 'Propose an event',
    },
    
    // FAQ
    faq: {
      title: 'Frequently asked questions',
      items: [
        {
          id: 'faq-1',
          question: 'What is the Business Club France–Latvia?',
          answer: 'The Business Club France–Latvia is a bilateral business network that facilitates economic exchanges, connections and joint initiatives between French and Latvian companies, institutions and decision-makers.',
        },
        {
          id: 'faq-2',
          question: 'Who is the Business Club France–Latvia for?',
          answer: 'The Business Club is for French and Latvian companies, executives, investors as well as institutions and organizations wishing to develop economic cooperation between France, Latvia and Northern Europe.',
        },
        {
          id: 'faq-3',
          question: 'What types of services does the Business Club offer?',
          answer: 'The Business Club acts as a neutral entry point. It facilitates connections, project guidance, organization of economic events and development of bilateral initiatives.',
        },
        {
          id: 'faq-4',
          question: 'How does the Business Club intervene in economic projects?',
          answer: 'The Business Club intervenes mainly upstream of projects, helping to clarify the context, identify key issues and connect project leaders with relevant contacts in the Franco-Latvian ecosystem.',
        },
        {
          id: 'faq-5',
          question: 'When can the Business Club be useful in a project?',
          answer: 'The Business Club is particularly useful during the reflection, structuring or launch phases of a project, providing feedback and targeted access to the Franco-Latvian economic ecosystem.',
        },
        {
          id: 'faq-6',
          question: 'How to propose an event to the Business Club France–Latvia?',
          answer: 'Members and partners can submit event proposals via the website. Each proposal is reviewed to ensure its relevance and collective interest.',
        },
        {
          id: 'faq-7',
          question: 'How to contact the Business Club France–Latvia?',
          answer: 'Requests can be submitted via the contact form on the website. They are analyzed by the Business Club to propose appropriate guidance or connection when relevant.',
        },
      ],
    },
    
    // Contact Form
    contact: {
      title: 'Submit a request to the Business Club',
      disclaimer: 'The Business Club France–Latvia does not provide commercial services through this site. Requests are reviewed and directed according to their nature.',
      fields: {
        nom: 'Name / First name',
        organisation: 'Organization',
        fonction: 'Role / Position',
        email: 'Email',
        telephone: 'Phone number',
        paysConcernes: 'Countries concerned',
        natureRequest: 'Nature of request',
        timeline: 'Project timeline',
        message: 'Message / Description',
        consentement: 'I agree that my request will be transmitted and processed by the Business Club France–Latvia.',
      },
      placeholders: {
        nom: 'Your full name',
        organisation: 'Organization name',
        fonction: 'Your position',
        email: 'your@email.com',
        telephone: '+371 20 000 000',
        paysConcernes: 'Ex: France, Latvia, Estonia...',
        message: 'Describe your request...',
      },
      natureOptions: [
        { id: 'mise-en-relation', label: 'Business connection' },
        { id: 'projet-export', label: 'Export / cooperation project' },
        { id: 'proposition-evenement', label: 'Event proposal' },
        { id: 'information-generale', label: 'General information' },
        { id: 'autre', label: 'Other' },
      ],
      timelineOptions: [
        { id: 'reflexion', label: 'Reflection' },
        { id: 'court-terme', label: 'Short term' },
        { id: 'en-cours', label: 'Ongoing' },
      ],
      submit: 'Submit request',
      submitting: 'Sending...',
      success: 'Your request has been successfully transmitted to the Business Club France–Latvia. It will be analyzed and directed according to its nature.',
      errorRequired: 'Please fill in all required fields and accept the conditions.',
      errorNature: 'Please select at least one type of request.',
      errorEmail: 'Please enter a valid email address.',
      errorGeneral: 'An error occurred. Please try again.',
    },
    
    // Footer
    footer: {
      tagline: 'Bilateral business network France–Latvia',
      copyright: '© 2025 Business Club France–Latvia. All rights reserved.',
      address: 'Miera iela 2, Rīga, LV-1001',
    },
  },
  
  lv: {
    // Navigation
    nav: {
      mission: 'Misija',
      services: 'Pakalpojumi',
      process: 'Darbība',
      faq: 'BUJ',
      contact: 'Kontakti',
    },
    
    // Hero
    hero: {
      eyebrow: 'Francija – Latvija',
      title: 'Francijas–Latvijas biznesa tīkls',
      subtitle: 'Business Club France–Latvia veicina ekonomisko apmaiņu, biznesa sakarus un pasākumus starp Francijas un Latvijas uzņēmumiem, institūcijām un ekonomikas dalībniekiem.',
      ctaPrimary: 'Iesniegt pieprasījumu',
      ctaSecondary: 'Piedāvāt pasākumu',
    },
    
    // Mission
    mission: {
      title: 'Biznesa kluba loma',
      description: 'Business Club France–Latvia darbojas kā neitrāls ieejas punkts ekonomiskajai sadarbībai starp Franciju un Latviju. Tas veicina apmaiņu, projektu vadību un sakarus starp uzņēmumiem, institūcijām un lēmumu pieņēmējiem.',
    },
    
    // Services
    services: {
      title: 'Mūsu darbības un pakalpojumi',
      items: [
        {
          id: 1,
          title: 'Ekonomiskie sakari',
          description: 'Sakaru veicināšana starp Francijas un Latvijas uzņēmumiem, partneriem, institūcijām un ekonomikas dalībniekiem.',
          icon: 'network',
        },
        {
          id: 2,
          title: 'Projektu vadība',
          description: 'Palīdzība ekonomisko, sadarbības vai starptautiskās attīstības projektu precizēšanā.',
          icon: 'compass',
        },
        {
          id: 3,
          title: 'Ekonomiskie pasākumi',
          description: 'B2B tikšanos, konferenču un tematisko apaļo galdu organizēšana un popularizēšana.',
          icon: 'calendar',
        },
        {
          id: 4,
          title: 'Piekļuve vietējai ekosistēmai',
          description: 'Savienojums ar atbilstošiem profesionālajiem un institucionālajiem tīkliem.',
          icon: 'building',
        },
        {
          id: 5,
          title: 'Divpusējā sadarbība',
          description: 'Atbalsts kopīgām Francijas un Latvijas dalībnieku iniciatīvām.',
          icon: 'handshake',
        },
      ],
    },
    
    // Audience
    audience: {
      title: 'Kam paredzēts Biznesa klubs',
      items: [
        {
          id: 1,
          title: 'Francijas uzņēmumi',
          description: 'MVU un vidēji uzņēmumi, kas vēlas attīstīt savu darbību Latvijā un Baltijas valstīs.',
          icon: 'briefcase',
        },
        {
          id: 2,
          title: 'Latvijas uzņēmumi',
          description: 'Latvijas uzņēmumi, kas meklē partnerattiecības ar Francijas dalībniekiem.',
          icon: 'building2',
        },
        {
          id: 3,
          title: 'Institūcijas un organizācijas',
          description: 'Ekonomiskās un institucionālās organizācijas, kas iesaistītas divpusējā sadarbībā.',
          icon: 'landmark',
        },
      ],
    },
    
    // Process
    process: {
      title: 'Kā tas darbojas',
      steps: [
        {
          id: 1,
          step: '01',
          title: 'Iesniegums',
          description: 'Iesniedziet pieprasījumu, izmantojot kontaktformu',
        },
        {
          id: 2,
          step: '02',
          title: 'Analīze',
          description: 'Jūsu pieprasījumu izskata Biznesa klubs',
        },
        {
          id: 3,
          step: '03',
          title: 'Virzība',
          description: 'Savienojums, vadība vai uzaicinājums uz pasākumu',
        },
      ],
    },
    
    // Event
    event: {
      title: 'Piedāvāt pasākumu',
      description: 'Business Club France–Latvia pieņem pasākumu piedāvājumus no saviem biedriem vai partneriem: konferences, B2B tikšanās, apaļos galdus vai ekonomiskās delegācijas. Katrs piedāvājums tiek izskatīts, lai nodrošinātu tā atbilstību un kolektīvo interesi.',
      cta: 'Piedāvāt pasākumu',
    },
    
    // FAQ
    faq: {
      title: 'Biežāk uzdotie jautājumi',
      items: [
        {
          id: 'faq-1',
          question: 'Kas ir Business Club France–Latvia?',
          answer: 'Business Club France–Latvia ir divpusējs biznesa tīkls, kas veicina ekonomisko apmaiņu, sakarus un kopīgas iniciatīvas starp Francijas un Latvijas uzņēmumiem, institūcijām un lēmumu pieņēmējiem.',
        },
        {
          id: 'faq-2',
          question: 'Kam paredzēts Business Club France–Latvia?',
          answer: 'Biznesa klubs ir paredzēts Francijas un Latvijas uzņēmumiem, vadītājiem, investoriem, kā arī institūcijām un organizācijām, kas vēlas attīstīt ekonomisko sadarbību starp Franciju, Latviju un Ziemeļeiropu.',
        },
        {
          id: 'faq-3',
          question: 'Kādus pakalpojumus piedāvā Biznesa klubs?',
          answer: 'Biznesa klubs darbojas kā neitrāls ieejas punkts. Tas veicina sakarus, projektu vadību, ekonomisko pasākumu organizēšanu un divpusējo iniciatīvu attīstību.',
        },
        {
          id: 'faq-4',
          question: 'Kā Biznesa klubs iesaistās ekonomiskajos projektos?',
          answer: 'Biznesa klubs galvenokārt iesaistās projektu sākumposmā, palīdzot precizēt kontekstu, identificēt galvenos jautājumus un savienot projektu vadītājus ar atbilstošiem kontaktiem Francijas-Latvijas ekosistēmā.',
        },
        {
          id: 'faq-5',
          question: 'Kad Biznesa klubs var būt noderīgs projektā?',
          answer: 'Biznesa klubs ir īpaši noderīgs projekta pārdomu, strukturēšanas vai uzsākšanas fāzēs, sniedzot atgriezenisko saiti un mērķtiecīgu piekļuvi Francijas-Latvijas ekonomiskajai ekosistēmai.',
        },
        {
          id: 'faq-6',
          question: 'Kā piedāvāt pasākumu Business Club France–Latvia?',
          answer: 'Biedri un partneri var iesniegt pasākumu piedāvājumus, izmantojot tīmekļa vietni. Katrs piedāvājums tiek izskatīts, lai nodrošinātu tā atbilstību un kolektīvo interesi.',
        },
        {
          id: 'faq-7',
          question: 'Kā sazināties ar Business Club France–Latvia?',
          answer: 'Pieprasījumus var iesniegt, izmantojot kontaktformu tīmekļa vietnē. Biznesa klubs tos analizē, lai piedāvātu atbilstošu vadību vai savienojumu, ja tas ir piemēroti.',
        },
      ],
    },
    
    // Contact Form
    contact: {
      title: 'Iesniegt pieprasījumu Biznesa klubam',
      disclaimer: 'Business Club France–Latvia nesniedz komerciālus pakalpojumus caur šo vietni. Pieprasījumi tiek izskatīti un virzīti atbilstoši to raksturam.',
      fields: {
        nom: 'Vārds / Uzvārds',
        organisation: 'Organizācija',
        fonction: 'Loma / Amats',
        email: 'E-pasts',
        telephone: 'Tālrunis',
        paysConcernes: 'Iesaistītās valstis',
        natureRequest: 'Pieprasījuma veids',
        timeline: 'Projekta laika grafiks',
        message: 'Ziņojums / Apraksts',
        consentement: 'Es piekrītu, ka mans pieprasījums tiks nosūtīts un apstrādāts Business Club France–Latvia.',
      },
      placeholders: {
        nom: 'Jūsu pilns vārds',
        organisation: 'Organizācijas nosaukums',
        fonction: 'Jūsu amats',
        email: 'jusu@epasts.lv',
        telephone: '+371 20 000 000',
        paysConcernes: 'Piem.: Francija, Latvija, Igaunija...',
        message: 'Aprakstiet savu pieprasījumu...',
      },
      natureOptions: [
        { id: 'mise-en-relation', label: 'Biznesa sakari' },
        { id: 'projet-export', label: 'Eksporta / sadarbības projekts' },
        { id: 'proposition-evenement', label: 'Pasākuma piedāvājums' },
        { id: 'information-generale', label: 'Vispārīga informācija' },
        { id: 'autre', label: 'Cits' },
      ],
      timelineOptions: [
        { id: 'reflexion', label: 'Pārdomas' },
        { id: 'court-terme', label: 'Īstermiņā' },
        { id: 'en-cours', label: 'Notiekošs' },
      ],
      submit: 'Iesniegt pieprasījumu',
      submitting: 'Sūta...',
      success: 'Jūsu pieprasījums ir veiksmīgi nosūtīts Business Club France–Latvia. Tas tiks analizēts un virzīts atbilstoši tā raksturam.',
      errorRequired: 'Lūdzu, aizpildiet visus obligātos laukus un pieņemiet nosacījumus.',
      errorNature: 'Lūdzu, atlasiet vismaz vienu pieprasījuma veidu.',
      errorEmail: 'Lūdzu, ievadiet derīgu e-pasta adresi.',
      errorGeneral: 'Radās kļūda. Lūdzu, mēģiniet vēlreiz.',
    },
    
    // Footer
    footer: {
      tagline: 'Divpusējs biznesa tīkls Francija–Latvija',
      copyright: '© 2025 Business Club France–Latvia. Visas tiesības aizsargātas.',
      address: 'Miera iela 2, Rīga, LV-1001',
    },
  },
};

export const heroImages = [
  {
    id: 'paris-1',
    url: 'https://images.unsplash.com/photo-1431274172761-fca41d930114?w=1920&q=80',
    alt: 'Paris - Tour Eiffel',
    city: 'Paris',
  },
  {
    id: 'riga-1',
    url: 'https://images.unsplash.com/photo-1685470934582-3636319a3be9?w=1920&q=80',
    alt: 'Riga - Vieille ville',
    city: 'Rīga',
  },
  {
    id: 'paris-2',
    url: 'https://images.unsplash.com/photo-1570097703229-b195d6dd291f?w=1920&q=80',
    alt: 'Paris - Seine',
    city: 'Paris',
  },
  {
    id: 'riga-2',
    url: 'https://images.unsplash.com/photo-1683730796330-06e60e3438d8?w=1920&q=80',
    alt: 'Riga - Vue aérienne',
    city: 'Rīga',
  },
  {
    id: 'paris-3',
    url: 'https://images.unsplash.com/photo-1526821799652-2dc51675628e?w=1920&q=80',
    alt: 'Paris - Soirée',
    city: 'Paris',
  },
  {
    id: 'riga-3',
    url: 'https://images.unsplash.com/photo-1522054541898-adc6abd570e5?w=1920&q=80',
    alt: 'Riga - Panorama',
    city: 'Rīga',
  },
];

export const serviceImages = {
  network: 'https://images.unsplash.com/photo-1675716921224-e087a0cca69a?w=600&q=80',
  compass: 'https://images.unsplash.com/photo-1529119368496-2dfda6ec2804?w=600&q=80',
  calendar: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&q=80',
  building: 'https://images.unsplash.com/photo-1573497491208-6b1acb260507?w=600&q=80',
  handshake: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=600&q=80',
};

export default translations;
